import _PropTypes from 'prop-types';
import classNames from 'classnames';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { AriaLiveRegionsProvider } from './AriaLiveRegions.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var GlobalStyles = createGlobalStyle(["", ";"], function (props) {
  return props.theme.global;
});

var Theme = function Theme(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/jsx("div", {
    style: style,
    className: classNames(theme.global && "ui-theme-root", className),
    dir: theme.isRTL ? "rtl" : "ltr",
    children: /*#__PURE__*/jsx(ThemeProvider, {
      theme: theme,
      children: /*#__PURE__*/jsxs(AriaLiveRegionsProvider, {
        children: [/*#__PURE__*/jsx(GlobalStyles, {}), children]
      })
    })
  });
};

Theme.propTypes = {
  "children": _PropTypes.node,
  "className": _PropTypes.string,
  "style": _PropTypes.object,
  "theme": _PropTypes.object.isRequired
};
Theme.displayName = "Theme";

export { Theme };
